import { AccountClosureGridComponent } from './accountmaster/account-closure-grid/account-closure-grid.component';
import { AccountClosureComponent } from './accountmaster/account-closure/account-closure.component';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import {RouterModule,Routes} from '@angular/router';
import { BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { AppComponent } from './app.component';
import { HeaderComponent } from './common/header/header.component';
import { MenuComponent } from './common/menu/menu.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { HomepageComponent } from './homepage/homepage.component';
import { MatTabsModule } from '@angular/material/tabs';
import {NgxPaginationModule} from 'ngx-pagination';


import {Component} from '@angular/core';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatRadioModule} from '@angular/material/radio';

// Masters Component

import { AgentCreationGridComponent } from './masters/agent-creation-grid/agent-creation-grid.component';
import { AgentCreationsComponent } from './masters/agent-creations/agent-creations.component';
import { AreaCreationGridComponent } from './masters/area-creation-grid/area-creation-grid.component';
import { AreaCreationsComponent } from './masters/area-creations/area-creations.component';
import { BankcreationComponent } from './masters/bankcreation/bankcreation.component';
import { BankcreationGridComponent } from './masters/bankcreation-grid/bankcreation-grid.component';
import { CastemastercreationComponent } from './masters/castemastercreation/castemastercreation.component';
import {CastemastercreationGridComponent} from './masters/castemastercreation-grid/castemastercreation-grid.component';
import { CustomerCreationComponent } from './masters/customer-creation/customer-creation.component';
import { CustomerCreationGridComponent } from './masters/customer-creation-grid/customer-creation-grid.component';
import { CustomerRiskAnalysisComponent} from './masters/customer-risk-analysis/customer-risk-analysis.component';
import { CustomerRiskAnalysisGridComponent} from './masters/customer-risk-analysis-grid/customer-risk-analysis-grid.component';
import { LedgerAccountComponent} from './masters/ledger-account/ledger-account.component';
import { LedgerAccountGridComponent} from './masters/ledger-account-grid/ledger-account-grid.component';
import { MasterMenuComponent } from './masters//master-menu/master-menu.component';


// Utility Component

// import { UltilitiesComponent } from './ultilities/ultilities.component';
// import { UltilitiesMenuComponent } from './ultilities/ultilities-menu/ultilities-menu.component';
// import { UserComponent } from './ultilities/user/user.component';
// import { SettingComponent } from './ultilities/setting/setting.component';
// import { RolesComponent } from './ultilities/roles/roles.component';
// import { RolesGridComponent } from './ultilities/roles/roles-grid/roles-grid.component';
// import { RolesFormComponent } from './ultilities/roles/roles-form/roles-form.component';
// import { UserGridComponent } from './ultilities/user/user-grid/user-grid.component';
// import { UserFormComponent } from './ultilities/user/user-form/user-form.component';
// import { ClaimGridComponent } from './ultilities/claims/claims/claim-grid/claim-grid.component';
// import { ClaimFormComponent } from './ultilities/claims/claims/claim-form/claim-form.component';
// import { ChangePasswordComponent } from './ultilities/change-password/change-password.component';
// import { ClaimsComponent } from './ultilities/claims/claims/claims.component';


//Registrattion 

//

import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { appRoutes } from '../route';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { UserCreationService } from './shared/user-creation.service';
import { AccountmasterMenuComponent } from './accountmaster/accountmaster-menu/accountmaster-menu.component';
import { DepositRenewalComponent } from './accountmaster/deposit-renewal/deposit-renewal.component';
import { DepositRenewalGridComponent } from './accountmaster/deposit-renewal-grid/deposit-renewal-grid.component';
import { GsGaCreationComponent } from './accountmaster/gs-ga-creation/gs-ga-creation.component';
import { GsGaCreationGridComponent } from './accountmaster/gs-ga-creation-grid/gs-ga-creation-grid.component';
import { InactiveDormandComponent } from './accountmaster/inactive-dormand/inactive-dormand.component';
import { InactiveDormandGridComponent } from './accountmaster/inactive-dormand-grid/inactive-dormand-grid.component';
import { InstructionEntryComponent } from './accountmaster/instruction-entry/instruction-entry.component';
import { InstructionEntryGridComponent } from './accountmaster/instruction-entry-grid/instruction-entry-grid.component';
import { LoanApplicationComponent } from './accountmaster/loan-application/loan-application.component';
import { LoanApplicationGridComponent } from './accountmaster/loan-application-grid/loan-application-grid.component';
import { LoanSanctionComponent } from './accountmaster/loan-sanction/loan-sanction.component';
import { LoanSanctionGridComponent } from './accountmaster/loan-sanction-grid/loan-sanction-grid.component';
import { MemberCreationComponent } from './accountmaster/member-creation/member-creation.component';
import { MemberCreationGridComponent } from './accountmaster/member-creation-grid/member-creation-grid.component';
import { NewDepositComponent } from './accountmaster/new-deposit/new-deposit.component';
import { NewDepositGridComponent } from './accountmaster/new-deposit-grid/new-deposit-grid.component';
import { PigmyCreationComponent } from './accountmaster/pigmy-creation/pigmy-creation.component';
import { PigmyCreationGridComponent } from './accountmaster/pigmy-creation-grid/pigmy-creation-grid.component';
import { SbAccountComponent } from './accountmaster/sb-account/sb-account.component';
import { SbAccountGridComponent } from './accountmaster/sb-account-grid/sb-account-grid.component';

import {TooltipModule} from "ngx-tooltip";
@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
   
    
    
    DashboardComponent,
    
   
    
    HomepageComponent,
    CustomerRiskAnalysisGridComponent,
    MenuComponent,
    AgentCreationGridComponent,
    AgentCreationsComponent,
    AreaCreationGridComponent,
    AreaCreationsComponent,
    BankcreationComponent,
    BankcreationGridComponent,
    CastemastercreationComponent,
    CastemastercreationGridComponent,
    CustomerCreationComponent,
    CustomerCreationGridComponent,
    CustomerRiskAnalysisComponent,
    CustomerCreationGridComponent,
    LedgerAccountComponent,
    LedgerAccountGridComponent,
    MasterMenuComponent,

    AccountClosureComponent,
    AccountClosureGridComponent,
    AccountmasterMenuComponent,
    DepositRenewalComponent,
    DepositRenewalGridComponent,
    GsGaCreationComponent,
    GsGaCreationGridComponent,
    InactiveDormandComponent,
    InactiveDormandGridComponent,
    InstructionEntryComponent,
    InstructionEntryGridComponent,
    LoanApplicationComponent,
    LoanApplicationGridComponent,
    LoanSanctionComponent,
    LoanSanctionGridComponent,
    MemberCreationComponent,
    MemberCreationGridComponent,
    NewDepositComponent,
    NewDepositGridComponent,
    PigmyCreationComponent,
    PigmyCreationGridComponent,
    SbAccountComponent,
    SbAccountGridComponent

  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    MatCheckboxModule,
    MatRadioModule,
    FormsModule,
    MatTabsModule,
    ReactiveFormsModule,
    HttpClientModule,
    NgxPaginationModule,
  
    RouterModule.forRoot(appRoutes)
  ],
  //UserService, ErrorHandler,
  providers: [UserCreationService],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts